import clsx from 'clsx';
import React, { useEffect, useRef, useState } from 'react';
import 'wicg-inert';

import Portal from 'layout/atoms/Portal';

import { ReactComponent as CloseIcon } from 'assets/icons/close.svg';
import styles from './modal.module.scss';

const Modal = (props: {
    open: boolean;
    size?: 's' | 'm' | 'l';
    onClose: () => void;
    locked?: boolean;
    noStyling?: boolean;
    children: React.ReactNode;
}) => {
    const [active, setActive] = useState(false);
    const { open, onClose, locked, noStyling, children } = props;
    const backdrop = useRef<HTMLInputElement>(null);
    const backdropClasses = clsx(styles.backdrop, {
        [styles.backdropActive]: active && open,
    });
    const contentClasses = clsx(
        styles.content,
        styles[props.size ? props.size : 'm'],
        {
            [styles.contentActive]: active && open,
        }
    );

    useEffect(() => {
        const { current } = backdrop;
        const transitionEnd = () => setActive(open);
        const keyHandler = (e: any) =>
            !locked && [27].indexOf(e.which) >= 0 && onClose();
        const clickHandler = (e: any) =>
            !locked && e.target === current && onClose();

        if (current) {
            current.addEventListener('transitionend', transitionEnd);
            current.addEventListener('click', clickHandler);
            window.addEventListener('keyup', keyHandler);
        }

        if (open) {
            window.setTimeout(() => {
                // document.activeElement?.blur();
                setActive(open);
                document.querySelector('#root')?.setAttribute('inert', 'true');
                document.body.style.overflow = 'hidden';
            }, 10);
        }

        return () => {
            if (current) {
                current.removeEventListener('transitionend', transitionEnd);
                current.removeEventListener('click', clickHandler);
            }

            document.querySelector('#root')?.removeAttribute('inert');
            document.body.style.overflow = 'unset';
            window.removeEventListener('keyup', keyHandler);
        };
    }, [open, locked, onClose]);

    return (
        <>
            {(open || active) && (
                <Portal className="modal-portal">
                    <div ref={backdrop} className={backdropClasses}>
                        {noStyling ? (
                            children
                        ) : (
                            <div className={contentClasses}>
                                {children}

                                <div className={styles.closeButton}>
                                    <CloseIcon onClick={onClose} />
                                </div>
                            </div>
                        )}
                    </div>
                </Portal>
            )}
        </>
    );
};

export default Modal;
